<template>
  <QSelect
    class="sai-select"
    v-on="$listeners"
    v-bind="$attrs"
    :error="error"
    :dense="dense"
    :multiple="multiple"
    :clearable="clearable"
    :use-input="useInput"
    :hide-bottom-space="hideBottomSpace"
    :fill-input="fillInput"
    :menu-offset="menuOffset"
    :hide-selected="computedHideSelected"
    :popup-content-class="popupClasses"
    :behavior="behavior"
    borderless
    no-error-icon
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
    <template v-slot:selected-item="data">
      <QChip dense square :class="`bg-${color}`">
        <span class="text-white text-body2">{{ data.opt }}</span>
        <QBtn
          flat
          class="q-ml-sm"
          :ripple="false"
          round
          color="white"
          icon="eva-close"
          size="xs"
          @click="data.toggleOption(data.opt)"
        />
      </QChip>
    </template>
    <template v-slot:no-option>
      <QItem>
        <QItemSection class="text-weight-medium">
          No Options are available
        </QItemSection>
      </QItem>
    </template>
    <template v-if="multiple" v-slot:option="data">
      <QItem :dense="dense" v-bind="data.itemProps" v-on="data.itemEvents">
        <QItemSection class="row sai-select-popup-section">
          <Checkbox :value="data.selected" :label="data.opt" :readonly="true" />
        </QItemSection>
      </QItem>
    </template>
  </QSelect>
</template>

<script>
import { QSelect, QChip, QBtn, QItem, QItemSection } from 'quasar';

export default {
  name: 'SAISelect',
  props: {
    error: { default: false },
    multiple: { default: false },
    dense: { default: true },
    clearable: { default: false },
    useInput: { default: true },
    fillInput: { default: true },
    hideSelected: { default: true },
    hideBottomSpace: { default: true },
    behavior: {
      type: String,
      default: 'menu'
    },
    menuOffset: { type: Array, default: () => [0, -1] }
  },
  computed: {
    color() {
      return this.error ? 'negative' : 'primary';
    },
    popupClasses() {
      return `sai-select-popup ${this.error ? 'sai-select-popup--error' : ''}`;
    },
    computedHideSelected() {
      return this.multiple ? false : this.hideSelected;
    }
  },
  components: {
    QSelect,
    QChip,
    QBtn,
    QItem,
    QItemSection,
    Checkbox: () => import('../sai-checkbox')
  }
};
</script>

<style lang="sass">
.sai-select
  .q-field__control, .q-field__prepend, .q-field__append, .q-field__before, .q-field__after
    height: 44px

  .q-field__bottom
    padding-top: 6px
    font-size: 13px
    color: $grey-6

  .q-chip
    padding: 0 2px 0 10px
    margin: 0 4px

  .q-field__control
    background: $primary-light
    border-radius: $generic-border-radius
    padding-left: 12px !important
    padding-right: 12px !important
    border: 1px solid transparent

    input
      width: inherit !important
      min-width: 0 !important
      font-size: 16px
      color: $grey-8

  .q-select__dropdown-icon,
  .q-field__append,
  .q-spinner
    color: $primary !important

  input::placeholder
    color: $primary-semi-light

  &.q-field--focused.q-field--float .q-field__control
    border-color: $primary


.sai-select.q-field--error

  .q-field__control
    background: $negative-light

  .q-spinner,
  .q-field__append,
  .q-select__dropdown-icon
    color: $negative !important

  input::placeholder
    color: $negative-semi-light

  &.q-field--focused.q-field--float .q-field__control
    border-color: $negative

.sai-select-popup
  max-height: 300px

  .q-item--active
    color: $primary

  .q-manual-focusable--focused
    background: $primary
    color: white

.sai-select-popup.sai-select-popup--error
  .q-item--active
    color: $negative

  .q-manual-focusable--focused
    background: $negative
    color: white

.sai-select-popup-section
  pointer-events: none
</style>
